<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Sale', apiMethod: 'Sales', form: () => import('../forms/SaleForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Sale Container', apiMethod: 'SaleContainers', parentForeignKey: 'saleId', form: () => import('../forms/SaleContainerForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Containers', value: 'saleId', isCard: true, table: () => import('../tables/SaleContainersTable') },
                ],
                mainForm: () => import('../forms/SaleForm'),
                claimName: 'Sales',
                apiMethod: 'Sales',
            }
        }
    };
</script>
